import React, { Component } from 'react';
import { withRouter } from 'next/router';
import { WithRouterProps } from 'next/dist/client/with-router';
import Intercom from 'react-intercom';

import cx from 'classnames';

import Environments from 'constants/Environments';

import ArticleGenericPage from 'components/ArticleGenericPage';
import ErrorPage from 'styled/components/ErrorPage';
import { PageMeta as Meta } from 'components/Meta';
import PageHero from 'components/PageHero';
import ModuleSwitch from 'components/ModuleSwitch';

import {
  ArticleGenericPage as IArticleGenericPage,
  ErrorPage as IErrorPage,
  GenericPage,
} from 'types';

interface PassedProps {
  errorPage: IErrorPage;
  page: IArticleGenericPage | GenericPage | null;
}

type Props = PassedProps & WithRouterProps;

interface State {
  pageLoaded: boolean;
}

class GenericPageView extends Component<Props, State> {
  state: State = {
    pageLoaded: false,
  };

  componentDidMount() {
    this.setState({ pageLoaded: true });
  }
  render() {
    const { errorPage, page } = this.props;
    const { pageLoaded } = this.state;

    if (!page) return <ErrorPage errorPage={errorPage} />;

    if (page.type === 'articleGenericPage') {
      return <ArticleGenericPage page={page} />;
    }

    if (process.browser) {
      const currentHost = window.location.host;
      if (
        page.slug === '/style-guide' &&
        !(
          currentHost === Environments.LOCAL.host ||
          currentHost.includes(Environments.STAGING.vercelHost) ||
          currentHost.includes(Environments.STAGING.host)
        )
      ) {
        return <ErrorPage errorPage={errorPage} />;
      }
    }

    const pageShouldRenderWithoutAnimation = page.slug === '/learn';

    return (
      <div className="relative">
        <Meta
          title={page.hero.title}
          description={page.hero.description}
          image={page.hero.desktopImage.src}
          seo={page.seo}
        />
        <PageHero
          hero={page.hero}
          withoutAnimation={pageShouldRenderWithoutAnimation}
        />
        <div
          className={cx(
            'relative z-2 transition-opacity transition-delay-800 ',
            {
              'opacity-0': !pageShouldRenderWithoutAnimation && !pageLoaded,
            }
          )}
        >
          <ModuleSwitch modules={page.modules} />
        </div>
        {page.showIntercom && (
          <Intercom appID={process.env.intercomAppId as string} />
        )}
      </div>
    );
  }
}

export default withRouter(GenericPageView);
